import { avatarToneClassName } from "@/lib/avatar"
import { personInitials, type PersonName } from "@/lib/person-name"
import { cn } from "@/lib/utils"

export type AvatarSize = 20 | 24 | 28 | 32 | 36 | 40 | 64

export type PersonAvatarProps = {
  person: PersonName
  size?: AvatarSize
  state?: "default" | "inactive" | "pending"
  className?: string
}

const SIZE_CLASS: Record<AvatarSize, string> = {
  20: "size-5 rounded-md text-[9px]",
  24: "size-6 rounded-lg text-[10px]",
  28: "size-7 rounded-lg text-[11px]",
  32: "size-8 rounded-lg text-xs",
  36: "size-9 rounded-lg text-[13px]",
  40: "size-10 rounded-lg text-sm",
  64: "size-16 rounded-lg text-[22px]",
}

export function PersonAvatar({ person, size = 24, state = "default", className }: PersonAvatarProps) {
  return (
    <span
      aria-hidden
      className={cn(
        "inline-flex shrink-0 items-center justify-center leading-none font-semibold tracking-tight select-none",
        SIZE_CLASS[size],
        state === "default" && avatarToneClassName(person.email),
        state === "inactive" && "bg-[var(--ui-avatar-inactive-bg)] text-[var(--ui-avatar-inactive-fg)]",
        state === "pending" && "border border-dashed border-ui-border-strong bg-transparent text-ui-text-muted",
        className,
      )}
    >
      {personInitials(person)}
    </span>
  )
}
